import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zMeasurementChartEntity = z.object({
  mcEntityId: zUid,
  entityId: zUid,
  mcServiceId: zUid,
  sizeLineEntityId: zUid,
  baseSizeEntityId: zUid,
  mcName: z.string(),
  comment: z.string(),
});
export type ZMeasurementChartEntity = z.infer<typeof zMeasurementChartEntity>;

export type NewMeasurementChartEntityData = Omit<
  ZMeasurementChartEntity,
  "mcEntityId"
>;

const zMCPointName = z.object({
  id: zUid.nullable(),
  name: z.string().nullable(),
});
export type ZMCPointName = z.infer<typeof zMCPointName>;

const zMCVersion = z.object({
  id: zUid,
  name: z.string(),
});
export type ZMCVersion = z.infer<typeof zMCVersion>;

export const zSampleMcPoint = z.object({
  id: zUid,
  value: z.number().nullable(),
  sampleId: zUid.nullable(),
  sampleName: z.string().nullable(),
});
export type ZSampleMcPoint = z.infer<typeof zSampleMcPoint>;

export const zMCPointValue = z.object({
  id: zUid,
  version: zMCVersion,
  value: z.number().nullable(),
  sampleMcPoint: zSampleMcPoint.array().nullish(),
});
export type ZMCPointValue = z.infer<typeof zMCPointValue>;

const zMCSize = z.object({
  id: zUid,
  name: z.string(),
  pointValues: zMCPointValue.array(),
});
export type ZMCSize = z.infer<typeof zMCSize>;

export const zMCPoint = z.object({
  id: zUid,
  point: zMCPointName,
  description: z.string().nullable(),
  tolPlus: z.number().nullable(),
  tolMinus: z.number().nullable(),
  resizeValuePlus: z.number().nullable(),
  resizeValueMinus: z.number().nullable(),
  qc: z.boolean(),
  sizes: zMCSize.array(),
});
export type ZMCPoint = z.infer<typeof zMCPoint>;

export const zMCRow = z.object({
  mcPoint: zMCPoint,
});
export type ZMCRow = z.infer<typeof zMCRow>;

const zMCTable = z.object({
  rows: zMCRow.array(),
});
export type ZMCTable = z.infer<typeof zMCTable>;

const zMCSizeColumn = z.object({
  id: zUid,
  name: z.string(),
});
export type ZMCSizeColumn = z.infer<typeof zMCSizeColumn>;

export const zMeasurementChart = z.object({
  measurementChartEntityDto: zMeasurementChartEntity.nullable(),
  tableDto: zMCTable.nullable(),
  columns: zMCSizeColumn.array().nullable(),
});
export type ZMeasurementChart = z.infer<typeof zMeasurementChart>;
